<template>
  <div class="view-pdf-main">
    <Modal v-model="show" width="980" :title="titleStr" :footer-hide="true">
      <div class="view-pdf" :class="{ opacity: loading }">
        <iframe
          v-show="previewUrl"
          id="ifra"
          ref="Iframe"
          frameborder="0"
          :src="`${previewUrl}?fileId=${fileId}&token=${previewToken}`"
          width="100%"
          style="height: 100%"
        >
        </iframe>
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleBtn">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import cateringAdmin from '@/request/cateringAdmin/index.js';
import platformApi from '@/request/eduCenter/platform.js';
import commonApi from '@/request/common/index.js';
export default {
  props: {
    isFromCdn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      previewUrl: '',
      fileId: '',
      previewToken: '',
      downToken: '',
      downUrl: '',
      show: false,
      loading: true
    };
  },
  computed: {
    titleStr() {
      return `预览`;
    }
  },
  created() {

  },
  mounted() {
    // this.beforeLoad();
    this.iframeLoad();
  },
  methods: {
    // 下载token
    async getDownloadtoken(fileId) {
      this.fileId = fileId;

      this.$Spin.show();
      // const res = await cateringAdmin.getDownloadtoken(params);
      let res = {};
      if (this.isFromCdn) {
        res = await platformApi.getPreviewServiceTemplatePdfApi({
          fileId: fileId
        });
      } else {
        res = await commonApi.getPreviewToken({
          fileId: fileId
        });
      }

      this.$Spin.hide();
      if (res.status == 200) {
        // this.downUrl = res.message.downUrl
        this.previewUrl = res.message.previewUrl;
        this.previewToken = res.message.token;

        // this.downToken = res.message.token
      }
      this.show = true;
    },

    handleBtn() {
      this.show = false;
    },
    beforeLoad() {
      console.log('来到了---34');
      const hasLoaded1 = document.getElementById('iframeLoad');
      if (hasLoaded1) {
        return;
      }
      const meta = document.createElement('meta');
      meta['http-equiv'] = 'Content-Security-Polic';
      meta.content = 'upgrade-insecure-requests';
      meta.id = 'iframeLoad';
      document.head.appendChild(meta);
      console.log('加载了-----432', meta, document.head);
    },
    // iframe
    iframeLoad() {
      const iframe = document.querySelector('#ifra');
      // 兼容处理;
      if (iframe.attachEvent) {
        // IE
        iframe.attachEvent('onload', () => {
          this.loading = false;
        });
      } else {
        // 非IE

        iframe.onload = () => {
          this.loading = false;
        };
      }
    },
    async handleDown() {
      const params = {
        fileId: [this.fileId],
        type: 1
      };
      this.$Spin.show();
      const res = await cateringAdmin.getDownloadtoken(params);
      this.$Spin.hide();
      if (res.status == 200) {
        this.downUrl = res.message.downUrl;
        // this.previewUrl = res.message.downUrl
        this.downToken = res.message.token;
        const downloadElement = document.createElement('a');
        const href = `${this.downUrl}?fileId=${this.fileId}&token=${this.downToken}`;
        downloadElement.style.display = 'none';
        downloadElement.href = href;
        downloadElement.download = `${this.studentName}_${this.gradeClassName}_${this.orgName}`; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      }
    },
    async handleShow(fileId) {
      this.getDownloadtoken(fileId);
    }
  }
};
</script>

<style  lang="scss" scoped>
.view-pdf {
  height: 70vh;
  position: relative;
  margin-bottom: 20px;
  .iframe-main {
    height: 100%;
    position: relative;
  }
  .opacity {
    opacity: 0;
  }
  .modal-footer {
    text-align: right;
    padding: 10px 0;
  }
}
</style>
